import { get } from "./api";

const getMetadata = (reportId) => {
  const url = `/reports?id=${reportId}`;
  const promise = get(url);
  return promise;
};

export default getMetadata;
